<table
	mat-table
	class="list-container mb-3"
	[dataSource]="dataSource"
	matSort
	matSortActive="{{ sort.active }}"
	matSortDisableClear
	matSortDirection="{{ sort.direction }}"
>
	<ng-container matColumnDef="empty">
		<th
			mat-header-cell
			*matHeaderCellDef
			[colSpan]="resultColumns.length"
			class="text-center"
		>
			<div class="list-loading-shade" *ngIf="loading">
				<mat-progress-bar mode="indeterminate"></mat-progress-bar>
			</div>
			<em>{{ message }}</em>
		</th>
	</ng-container>

	<ng-container matColumnDef="job">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>Job Number</th>
		<td mat-cell *matCellDef="let assignment">
			<a [routerLink]="jobsFragments.detail(assignment.job?.id)">
				{{ assignment.job?.number }}
			</a>
		</td>
	</ng-container>

	<ng-container matColumnDef="start">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>Start</th>
		<td mat-cell *matCellDef="let assignment">
			{{ assignment.start | date: 'mediumDate':'utc' }}
		</td>
	</ng-container>
	<ng-container matColumnDef="end">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>End</th>
		<td mat-cell *matCellDef="let assignment">
			{{ assignment.end | date: 'mediumDate':'utc' }}
		</td>
	</ng-container>
	<ng-container matColumnDef="shifts">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>Shifts</th>
		<td mat-cell *matCellDef="let assignment">
			{{ assignment.shifts?.length }}
		</td>
	</ng-container>

	<tr
		mat-header-row
		*matHeaderRowDef="resultColumns"
		[class.hidden]="message"
	></tr>
	<tr
		mat-header-row
		*matHeaderRowDef="emptyColumns"
		[class.hidden]="!message"
	></tr>
	<tr mat-row *matRowDef="let customer; columns: resultColumns"></tr>
</table>

<div
	fxLayout
	fxLayoutAlign="start center"
	[class.hidden]="dataSource.data.length < 5"
>
	<mat-paginator
		class.hidden="true"
		pageSize="5"
		[pageSizeOptions]="[5, 10]"
		[showFirstLastButtons]="dataSource.data.length > 10"
	></mat-paginator>
</div>
